import validationSchema from "../validationSchema";

const formikSchema = (currentUser) => ({
  initialValues: {
    name: "",
    url: "",
    notes: "",
    category: "",
    attachments: [],
    customers: [
      {
        addedBy: currentUser?.name || "",
        name: "",
        isCurrentlyBuying: false,
        notes: "",
        annualProjectionInDollars: null,
      },
    ],
  },
  validationSchema,
});

export default formikSchema;
